import React from "react";
import { Content } from "../components/Content";
import { useWalletAssets } from "../hooks/useWalletAssets";

export const WalletInvestment = () => {
  const { boxes } = useWalletAssets(5);

  return (
    <div className="px-4 sm:px-6 md:px-10">
      <Content boxes={boxes} id={5} pageName="سرمایه گذاری" />
    </div>
  );
};
